import type { TestEvent } from '../types/index.js';

export function sizeOf(event: TestEvent): number {
  try {
    return Buffer.byteLength(JSON.stringify(event));
  } catch {
    return 0;
  }
}
